import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import React, { useEffect } from 'react';
import useUpdateReceiver from '../hooks/useUpdateReceiver';

const withUpdateReceiverPageInitial = (Component) => {
  const UpdateReceiverPageInitialComponent = (props) => {
    const { currentReceiver } = useFormAddReceiverStore();
    const { getReceiverInformationFn } = useUpdateReceiver();

    useEffect(() => {
      if (currentReceiver) return;
      getReceiverInformationFn();
    }, [currentReceiver]);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return UpdateReceiverPageInitialComponent;
};

export default withUpdateReceiverPageInitial;
